import styles from "./PhotographersGrid.module.css";
import { getAllPhotographers } from "../../../app/lib/prisma-db.js";
import Image from "next/image";
import Link from "next/link";

/**
 * PhotographersGrid Component
 * ---------------------------
 * This is a **server component** that:
 * - Fetches all photographers from the database (via Prisma).
 * - Displays them in a responsive grid layout.
 * - Each photographer card links to their individual profile page.
 */
export default async function PhotographersGrid() {
  // Fetch all photographers from the database using Prisma helper function
  const photographers = await getAllPhotographers();

  return (
    <section className={styles.photographersGrid}>
      {/* Loop through each photographer and render their info */}
      {photographers.map((photographer) => {
        // Build the URL for the photographer detail page
        // Example: /photographer/12-john_doe
        let url = "/photographer/" + photographer.id + "-" + slugify(photographer.name);

        return (
          <article key={photographer.id} className={styles.photographer}>
            {/* Link to the photographer’s detail page */}
            <Link href={url} style={{ textDecoration: 'none' }}>
              <div className={styles.photographerHeader}>
                {/* Photographer portrait */}
                <Image 
                  src={"/assets/" + photographer.portrait}
                  width={200}
                  height={200}
                  alt={photographer.name}
                  className={styles.portrait}
                />

                {/* Photographer’s name */}
                <h2 className={styles.name}>{photographer.name}</h2>
              </div>
            </Link>

            {/* Photographer information (location, tagline, and price) */}
            <div className={styles.photographerContent}>
              <p className={styles.location}>
                {photographer.city}, {photographer.country}
              </p>
              <p className={styles.tagline}>{photographer.tagline}</p>
              <p className={styles.price}>{photographer.price}€/jour</p>
            </div>
          </article>
        );
      })}
    </section>
  );
}

/**
 * slugify()
 * ---------
 * Utility function that converts a photographer’s name
 * into a URL-friendly string.
 * Example: "Jane Doe" → "jane_doe"
 */
function slugify(name) {
  return name
    .toLowerCase()
    .replace(/ /g, "_");
}
